import Enumeration from '@/common/enumeration.js'
import cloneDeep from 'lodash/cloneDeep'

export default {
  namespaced: true,

  state: {
    // danh sách bộ câu hỏi
    listStorageLibrary: {},
    // chi tiết 1 bộ câu hỏi
    storageLibrary: {},
    // danh sách câu hỏi muốn lấy
    questionLibrary: [],
    // component được chọn
    type: 0,
    // component được chọn khi back về trước đó
    typeBack: 0,
    // lấy id của danh sách  vừa mở
    storageID: ''
  },

  getters: {
    // /** Danh sách câu hỏi
    //  *  validate câu hỏi
    //  * @param {*} state
    //  * @returns
    //  */
    // questions (state) {
    //   if (state.storageLibrary.Questions?.length && state.storageLibrary.Questions?.every(question => !question.NumberNo)) {
    //     state.storageLibrary.Questions.map(question => {
    //       question.NumberNo = `${question.SortOrder}`

    //       return question
    //     })

    //   state.storageLibrary.ParentQuestions?.length && state.storageLibrary.ParentQuestions?.map(parenQuesion => {
    //     parenQuesion.NumberNo = `${$t('EnumResource.QuestionType.Group')}`
    //     parenQuesion.IsSeamless = true
    //     return parenQuesion
    //   })
    //   }

    //   const questions = convertExercise(state.storageLibrary).map((question, index) => {
    //     question.Index = index + 1
    //     if (question.Type === Enumeration.QuestionType.Group) {
    //       question.Id = state.storageLibrary.Id

    //       question.isAddQuestion = question.ChildrenQuestions.every(childrenQuestion => !!childrenQuestion.isAddQuestion)
    //     }
    //     return question
    //   })

    //   return questions || []
    // }

  },

  mutations: {

    /**
     * sự kiện chuyển màn của thư viện
     */
    setType (state, type) {
      state.typeBack = state.type
      state.type = type
    },

    /**
     * lấy danh sách câu hỏi cho vào kho
     * @param {*} state
     * @param {*} questionLibrary
     */
    setQuestionLibrary (state, questionLibrary) {
      state.questionLibrary = questionLibrary
    },

    /**
     * thêm 1 câu hỏi vào kho
     * @param {*} state
     * @param {*} object
     */
    addQuestionLibrary (state, questions) {
      const exerciseStoreIndex = state.listStorageLibrary.exerciseStores.findIndex(exerciseStore => {
        return exerciseStore.Id === state.storageLibrary.Id
      })
      if (state.listStorageLibrary.exerciseStores[exerciseStoreIndex]) {
        state.listStorageLibrary.exerciseStores[exerciseStoreIndex].isAddQuestion = true
      }

      state.questionLibrary.push(...questions)

      state.questionLibrary = state.questionLibrary.sort(function (a, b) {
        return a.SortOrder - b.SortOrder
      })
    },

    /**
     * xóa ds câu hỏi từ màn danh sách  khỏi kho
     * @param {*} state
     * @param {*} object
     */
    removeListQuestionLibrary (state, questions) {
      const questionsFilter = cloneDeep(state.questionLibrary)

      state.questionLibrary.forEach((element, index) => {
        if (element.Type === Enumeration.QuestionType.Group) {
          element.ChildrenQuestions.forEach(childrenQuestion => {
            if (questions === childrenQuestion) {
              questionsFilter.splice(index, 1)
            }
          })
        } else {
          if (questions.findIndex(question => question.Id === element.Id) > -1) {
            questionsFilter.splice(index, 1)
          }
        }
      })

      state.questionLibrary = questionsFilter
    },
    /**
     * xóa câu hỏi từ kho
     * @param {*} state
     * @param {*} index
     */
    removeQuestionLibrarybyLibrary (state, index) {
      state.questionLibrary.splice(index, 1)
    },

    /**
     * xóa câu hỏi khỏi kho từ ds câu hỏi
     * @param {*} state
     * @param {*} question
     */
    removeExerciseStore (state, exerciseStore) {
      const questionsFilter = state.questionLibrary.filter(item => {
        return exerciseStore?.Questions.findIndex(question => question.Id === item.Id && question.Index === item.Index) === -1
      })

      state.questionLibrary = questionsFilter
    },

    removeQuestion (state, question) {
      const questionIndex = state.questionLibrary.findIndex(element => element.Id === question.Id && element.index === question.index)
      const exerciseStores = state.listStorageLibrary.exerciseStores
      const exerciseStoreIndex = exerciseStores.findIndex(exerciseStore => exerciseStore.Id === question.Id)

      state.listStorageLibrary.exerciseStores[exerciseStoreIndex].isAddQuestion = exerciseStores[exerciseStoreIndex].Questions.some(question => !!question.isAddQuestion)
      state.questionLibrary.splice(questionIndex, 1)
    },

    /**
     * lưu chi tiết 1 bộ đề để xem chi tiết
     * @param {*} state
     * @param {*} storageLibrary
     */
    setStorageLibrary (state, storageLibrary) {
      state.storageLibrary = storageLibrary
    },

    setIsAddQuestions (state, params) {
      const exerciseStoreIndex = state.listStorageLibrary.exerciseStores.findIndex(exerciseStore => exerciseStore.Id === params.exerciseStore.Id)
      const questions = state.listStorageLibrary.exerciseStores[exerciseStoreIndex].Questions.map(question => {
        question.isAddQuestion = params.isAddQuestion
        return question
      })

      state.listStorageLibrary.exerciseStores[exerciseStoreIndex].Questions = questions
    },
    /**
     * lấy  chi tiết 1 bộ đề để xem chi tiết
     * @param {*} state
     * @param {*} storageLibrary
     */
    // getStorageLibrary (state) {
    //   const storageLibrary = state.listStorageLibrary.exerciseStores.filter(item => {
    //     return item.Id === state.storageID
    //   })
    //   state.storageLibrary = storageLibrary[0]
    // },

    /**
     *
     *  lưu 1 ds bộ đề
     */
    setListLibrary (state, storageLibrary) {
      state.listStorageLibrary = storageLibrary
    },

    updateQuestionsToExerciseLibrary (state, params) {
      state.listStorageLibrary.exerciseStores[params.index] = params.exerciseStore
    }
  }
}
